<select [(ngModel)]="viewModel.Value" (ngModelChange)="onChange($event)">
  <option *ngFor="let x of viewModel.AvailableList.Value" [ngValue]="x.Key">{{ x.Value }}</option>
</select>